import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterProyectoModel } from 'src/app/models/interfaces/proyectos/IFilterProyectoModel';
import { IProyectoModel } from 'src/app/models/interfaces/proyectos/IProyectoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterProyectoModel } from 'src/app/models/proyecto/FilterProyectoModel';
import { ProyectoModel } from 'src/app/models/proyecto/ProyectoModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ProyectoService } from 'src/app/services/proyecto/proyecto.service';

@Component({
  selector: 'app-configuracion-proyecto-listar',
  templateUrl: './configuracion-proyecto-listar.component.html',
  styleUrls: ['./configuracion-proyecto-listar.component.css']
})
export class ConfiguracionProyectoListarComponent implements OnInit {
  model!: SearchResultModel<IProyectoModel[]>;
  filter: IFilterProyectoModel = new FilterProyectoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceProyecto: ProyectoService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<IProyectoModel[]>(false, new Array<ProyectoModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceProyecto.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceProyecto
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceProyecto
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
